module.exports = __webpack_public_path__ + "img/logo.92981199.png";